import { stringify } from 'querystring';
import { ParsedQsType, HistoryType } from '@catalogo/service-americanas-product/src/helpers/product-condiction';
import { Condition } from './interfaces';

export const setSelectedOption = (parsedQs: ParsedQsType, history: HistoryType) => (type: string, value: string) => {
  const newQueryString = {
    ...parsedQs,
    [type]: value.toUpperCase(),
  };

  history.replace(`?${stringify(newQueryString)}`);
};

export const changeState = (
  setConditionSelected: React.Dispatch<React.SetStateAction<Condition>>,
  setSelectedOption: any
) => (value: Condition) => () => {
  setSelectedOption('condition', value);
  setConditionSelected(value);
};

export const translate = {
  new: 'novo',
  rewrapped: 'reembalado',
};
